export const defaultConstantFields = {
  name: "",
  value: "",
  isGlobal: false,
};

export const defaultFormulaTemplateFields = {
  name: "",
  description: "",
  value: "",
  isGlobal: false,
  awaitAllInput: false,
};

//The order of the elements in this object is important for formulaImport
export const defaultFormulaHeaderEntry = {
  formulaName: "Name",
  outputDeveui: "",
  outputSensor: "",
};

//The order of the elements in this object is important for formulaImport
export const defaultFormulaVariableEntry = {
  isConstant: false,
  id: "",
  sensor: "",
  trigger: true,
};
